import { styled } from "../../Theme";
export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 100%;
  background-color: ${(props) => props.theme.color.header};
`;

export const HeaderItemContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 33vw;
  min-height: 8em;
  box-sizing: border-box;
`;

export const HeaderNavigationContainer = styled.div`
  display: flex;
  max-width: 100%;
`;

export const HeaderNavbarContainer = styled.div`
  width: 50%;
  display: flex;
`;

export const HeaderImageContainer = styled.div<{ bg: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 8em;
  box-sizing: border-box;
  padding: 0.5em;
  background-image: url(${({ bg }) => bg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  max-width: 100%;
  justify-content: space-evenly;
`;

export const CenterItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface LogoProps {
  logo: string;
}

export const HeaderLogoContainer = styled.div`
  width: 30%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 1em;
  padding-bottom: 0em!important;
`;

export const Logo = styled.div<LogoProps>`
  align-self: center;
  background: ${(props) => `url(${props.logo})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 5em;
  width: 9em;
`;

export const Title = styled.div`
  margin-top: 0.5em;
  text-align: center;
  font-weight: normal;
  font-size: x-large;
  color: ${(props) => props.theme.color.text};
  white-space: pre-line;
`;

export const ProductLogo = styled.img`
  width: auto;
  height: 4em;
`;

export const HeaderMainTitleStyle = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  font-size: 2em;

  font-family: "Title";
  color: white;
  text-align: center;
  padding: 0.1em;

  @media (min-width: 1475px) {
    font-size: 4em;
  }

  @media (max-width: 1475px) {
    font-size: 4em;
    white-space: wrap;
    max-height: 3em;
  }

  @media (max-width: 400px) {
    font-size: 1.8em;
    white-space: wrap;
    max-height: 3em;
    max-width: 70%;
  }
`;

export const SeparatorLine = styled.div`
  border-bottom: solid white 0.1em;
  color: white;
  align-self: center;
  width: 40%;
`;

export const HeaderSubTitleStyle = styled.div`
  padding: 4em;
  width: 100%;
  min-width: 4em;
  max-width: 100%;
  color: white;
  text-align: center;
  padding: 0.5em;
  padding-bottom: 1em;
  box-sizing: border-box;

  @media (min-width: 1475px) {
    font-size: 1.4em;
  }

  @media (max-width: 1475px) {
    font-size: 1.4em;
    white-space: wrap;
  }

  @media (max-width: 400px) {
    font-size: 1em;
    white-space: wrap;
    max-width: 70%;
  }
`;
